// src/services/portainerAxios.js
import axios from "axios";

const portainerApi = axios.create({
    baseURL: process.env.REACT_APP_PORTAINER_BASE_URL, // Portainer base URL
    timeout: 15000,
});

// UI Access Token => X-API-Key
portainerApi.interceptors.request.use((config) => {
    config.headers = config.headers || {};
    config.headers["X-API-Key"] = process.env.REACT_APP_PORTAINER_API_KEY;
    return config;
});

export default portainerApi;
